// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipZIndex":"3","tooltipSpacing":"10px","accordionHeader":"S7ybOn-FPS3C","icon":"eGOFpXe6mO6p","title":"-NCpeOfTiG+y"};